

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component Attribute, Properties & Injected ------------------------------

    props: {
        gridType: {
            type: String,
            required: true,
            validator (value: String) {
                // The value must match one of these strings
                return ["fit", "fill"].includes(value.toString());
            }
        },

        heading: {
            type: String,
            required: false,
            default: ""
        }
    },

    computed: {
        classes (): Array<string> {
            const gridType = "grid-" + this.gridType;

            return [
                gridType,
                "grid-container"
            ];
        }
    }

    // -------------------------------------------------------------------------
});

